import Slider from 'react-slick';

import { PrevArrow, NextArrow } from './CarouselArrows';

const carouselSettings = {
  className: 'center',
  centerMode: true,
  centerPadding: '120px',
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        dots: true,
        dotsClass: 'slick-dots',
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        dots: true,
        dotsClass: 'slick-dots',
      },
    },
  ],
  nextArrow: <NextArrow className="slick-next" />,
  prevArrow: <PrevArrow className="slick-prev" />,
};

const Carousel = () => (
  <Slider {...carouselSettings}>
    <div
      className="slick-slide"
      data-slick-index={-2}
      aria-hidden="true"
      style={{ width: '756px' }}
      tabIndex={-1}
    >
      <div className="slick-content">
        <img
          src={`${process.env.REACT_APP_ASSETS_BASE_URL}/images/fff-pets.jpg`}
          alt="Dog Friendly"
        />
        <span>Dog Friendly</span>
      </div>
    </div>
    <div
      className="slick-slide"
      data-slick-index={-1}
      aria-hidden="true"
      style={{ width: '756px' }}
      tabIndex={-1}
    >
      <div className="slick-content">
        <img
          src={`${process.env.REACT_APP_ASSETS_BASE_URL}/images/fff-summer-house.jpg`}
          alt="Summer House"
        />
        <span>SUMMER HOUSE 2018</span>
      </div>
    </div>
    <div
      className="slick-slide"
      data-slick-index={0}
      aria-hidden="false"
      style={{ width: '756px' }}
      tabIndex={-1}
      role="option"
      aria-selected="true"
      aria-describedby="slick-slide00"
    >
      <div className="slick-content">
        <img
          src={`${process.env.REACT_APP_ASSETS_BASE_URL}/images/fff-studio.jpg`}
          alt="FFF Studio"
        />
        <span>FabFitFun&apos;s Studio</span>
      </div>
    </div>
    <div
      role="option"
      aria-selected="false"
      className="slick-slide"
      data-slick-index={1}
      aria-hidden="true"
      style={{ width: '756px' }}
      tabIndex={-1}
      aria-describedby="slick-slide01"
    >
      <div className="slick-content">
        <img
          src={`${process.env.REACT_APP_ASSETS_BASE_URL}/images/fff-pets.jpg`}
          alt="Dog Friendly"
        />
        <span>Dog Friendly</span>
      </div>
    </div>
    <div
      className="slick-slide"
      data-slick-index={2}
      aria-hidden="true"
      style={{ width: '756px' }}
      tabIndex={-1}
      role="option"
      aria-selected="false"
      aria-describedby="slick-slide02"
    >
      <div className="slick-content">
        <img
          src={`${process.env.REACT_APP_ASSETS_BASE_URL}/images/fff-summer-house.jpg`}
          alt="Summer House"
        />
        <span>SUMMER HOUSE 2018</span>
      </div>
    </div>
    <div
      className="slick-slide"
      data-slick-index={3}
      aria-hidden="true"
      style={{ width: '756px' }}
      tabIndex={-1}
    >
      <div className="slick-content">
        <img
          src={`${process.env.REACT_APP_ASSETS_BASE_URL}/images/fff-studio.jpg`}
          alt="FFF Studio"
        />
        <span>FabFitFun&apos;s Studio</span>
      </div>
    </div>
  </Slider>
);

export default Carousel;
